import { Dispatch } from 'react';
import { IMenuAction } from 'src/components/menu/SearchAndDropdownMenu';
import styles from './MainMenuButton.module.css';


//#region [Props]
type MainMenuButtonProps = {
	dispatch: Dispatch<IMenuAction>;
};
//#endregion

//#region [Component]
export default function MainMenuButton({ dispatch }: MainMenuButtonProps) {
	return <button className={styles.SMainMenuButton} onClick={() => dispatch({ type: "TOGGLE_MENU" })} aria-label="Meny">
		<div className={styles.SHamburger}>
			<span></span>
		</div>
		<div>Meny</div>
	</button>;
}
//#endregion

//#region [Styles]
//#region [Styles]
// Converted to CSS Modules (MainMenuButton.module.css) preserving SMainMenuButton/SHamburger
//#endregion



//#endregion
